export enum FeesStatusEnum {
  PENDING = 'PENDING',
  DISCOUNT_REQUESTED = 'DISCOUNT_REQUESTED',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED'
}
